import * as React from 'react';
import { Translate } from '../../shared/LanguageService';
import { FormGroup, FormControl, ControlLabel, HelpBlock, Button } from 'react-bootstrap';
import {
    IProductType,
    IProductProps,
    IProductCompensation,
    IEditAgreementViewModel
} from './Entities';
import AgreementsFormList from './AgreementsFormList';
import FormSelect from '../../components/common/FormSelect';
import FormValidationService from '../../shared/form/FormValidationService';
import { notInList } from './utils/listUtils';

interface IAgreementFormProps {
    agreement: IEditAgreementViewModel;
    productTypes: IProductType[];
    productCompensation: IProductCompensation;
    chosenProductType: string;
    onChange: (e: any) => void;
    addProductCompensation: () => void;
    onNameChange: (e: any) => void;
    onDescriptionChange: (e: any) => void;
    isFormValid: () => boolean;
    onProductTypeChange: (e: any) => void;
    errors: any;
    delete: (id: number, product: number) => void;
}

const AgreementsForm = (props: IAgreementFormProps) => {
    return (
        <div>
            <form>
                <FormGroup
                    validationState={FormValidationService.getValidationState(props.errors.name)}
                >
                    <ControlLabel>
                        {Translate('agreements/modal/form/input-label/name')}
                    </ControlLabel>
                    <FormControl
                        autoFocus
                        type="text"
                        name="name"
                        value={props.agreement.name ? props.agreement.name : ''}
                        onChange={props.onNameChange}
                    />
                    {props.errors && props.errors.name && (
                        <HelpBlock>{props.errors.name}</HelpBlock>
                    )}
                </FormGroup>
                <FormGroup
                    validationState={FormValidationService.getValidationState(
                        props.errors.description
                    )}
                >
                    <ControlLabel>
                        {Translate('agreements/modal/form/input-label/description')}
                    </ControlLabel>
                    <FormControl
                        componentClass="textarea"
                        name="description"
                        value={props.agreement.description ? props.agreement.description : ''}
                        onChange={props.onDescriptionChange}
                    />
                </FormGroup>
                <div className="row">
                    <div className="col-md-3">
                        <FormGroup>
                            <ControlLabel>
                                {Translate('agreements/modal/form/select-label/producttype')}
                            </ControlLabel>
                            <FormSelect
                                name="productType"
                                value={props.chosenProductType ? props.chosenProductType : ''}
                                onChange={props.onProductTypeChange}
                                defaultTranslateKey="agreements/modal/form/select-label/producttype/default"
                            >
                                {props.productTypes &&
                                    props.productTypes.map((pt: IProductType) => {
                                        return (
                                            <option value={pt.id as any} key={pt.id}>
                                                {pt.name}
                                            </option>
                                        );
                                    })}
                            </FormSelect>
                        </FormGroup>
                    </div>
                    <div className="col-md-3">
                        <FormGroup>
                            <ControlLabel>
                                {Translate('agreements/modal/form/select-label/product')}
                            </ControlLabel>
                            <FormSelect
                                name="productId"
                                value={
                                    props.productCompensation.productId
                                        ? (props.productCompensation.productId as any)
                                        : ''
                                }
                                onChange={props.onChange}
                                defaultTranslateKey="agreements/modal/form/select-label/product/default"
                            >
                                {props.productTypes &&
                                    props.productTypes.map((pt: IProductType) => {
                                        return pt.products.map((p: IProductProps) => {
                                            if (
                                                pt.id.toString() === props.chosenProductType &&
                                                notInList(props.agreement.productCompensations, p)
                                            ) {
                                                return (
                                                    <option value={p.id as any} key={p.id}>
                                                        {p.name} ({p.site.name})
                                                    </option>
                                                );
                                            }
                                        });
                                    })}
                            </FormSelect>
                        </FormGroup>
                    </div>
                    <div className="col-md-3">
                        <FormGroup>
                            <ControlLabel>
                                {Translate('agreements/modal/form/input-label/compensation')}
                            </ControlLabel>
                            <FormControl
                                name="compensation"
                                type="number"
                                value={
                                    props.productCompensation.compensation
                                        ? (props.productCompensation.compensation as any)
                                        : ''
                                }
                                placeholder={Translate(
                                    'agreements/modal/form/input-label/compensation'
                                )}
                                onChange={props.onChange}
                            />
                        </FormGroup>
                    </div>
                    <div className="col-md-3 no-label">
                        <FormGroup>
                            <Button
                                disabled={props.isFormValid()}
                                onClick={() => props.addProductCompensation()}
                                bsStyle="primary"
                            >
                                <i className="material-icons">add</i>{' '}
                                {Translate('agreements/modal/form/button-label/add')}
                            </Button>
                        </FormGroup>
                    </div>
                </div>
            </form>
            <AgreementsFormList
                productTypes={props.productTypes}
                productCompensations={props.agreement.productCompensations}
                delete={props.delete}
            />
        </div>
    );
};

export default AgreementsForm;
